import React, { RefObject, useState } from 'react';

import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import Form, { FormInstance } from 'antd/lib/form';

import { CreditCardsList, PaymentMethodBase } from '@components';
import { ICarDetails, IUserCard } from '@share/common-types';

import { ICardBooking } from '@common-types';
import { ICarsReviewBookState, setCarsCard } from '@store/slices';
import { RootState } from '@share/utils';
import { ILoginState } from '@share/store/slices';

import './style.scss';
import BillingAddressForm from '../billing-address-form/component';
import { isEmpty } from 'lodash';
import PaymentMethodsSelect from '../../../../../share/components/express-checkout-buttons/payment-methods-select/component';

interface IMapStateToProps {
  carsReviewBookStore: ICarsReviewBookState;
  loginStore: ILoginState;
}

interface IMapDispatchToProps {
  setCard: (card: ICardBooking) => void;
}

interface IProps extends IMapDispatchToProps, IMapStateToProps {
  car: ICarDetails;
  formRef: RefObject<FormInstance>;
  billingRef: RefObject<FormInstance>;
  handleBillingFormValidation: (billingForm: boolean) => void;
  multiplePayments?:any;
  setPaymentSelected?: (payment: string) => void;
  paymentSelected?: string;
  stripeExpressEnabled?: boolean;
  handlePaymentFormValidation?: any;
  scrollToPaymentSelect?: boolean;
  scrollToPaymentSelectDisabled?: () => void;
}

function CarsPaymentComponent(props: IProps) {   

  const {
    loginStore,
    carsReviewBookStore,
    formRef,
    setCard,
    billingRef,
    handleBillingFormValidation,
    multiplePayments,
    setPaymentSelected,
    paymentSelected,
    handlePaymentFormValidation,
    scrollToPaymentSelect,
    scrollToPaymentSelectDisabled,
    stripeExpressEnabled,
  } = props;
  const { account } = loginStore;
  const { card, errorsField, loadingBooking } = carsReviewBookStore;
  
  const [ refreshPayment, setRefreshPayment ] = useState(false);
    const [form] = Form.useForm<FormInstance>();

  const handleCardSelect = async (selectedCard: IUserCard) => {
    const { setCard } = props;
    await setCard(selectedCard);
    setRefreshPayment(true);
  }

  return (
    <div className="hotel-info">
      <div className="hotel-info__item border-top">
        <div className="hotel-info__item-content">
          <h4 className="hotel-info__title">
            <FormattedMessage id="tab.payment" />
          </h4>

            {stripeExpressEnabled && setPaymentSelected ? (
            <PaymentMethodsSelect setPaymentSelected={setPaymentSelected} multiplePayments={multiplePayments} scrollToPaymentSelect={scrollToPaymentSelect}
            scrollToPaymentSelectDisabled={scrollToPaymentSelectDisabled} />
            ) : null}

          {(paymentSelected === 'card' || !stripeExpressEnabled) ? (
            <PaymentMethodBase
              form={null}
              formRef={formRef}
              refreshData={refreshPayment}
              onDataRefreshed={() => setRefreshPayment(false)}
              card={card}
              errorsField={errorsField}
              loading={loadingBooking}
              setCard={(card) => setCard(card)}
              displaySave={account?.isPrivateTokenAccountType || account?.isPrivateLoginAccountType}
              disableInsurance
              isRequired
              display
              multiplePayments={multiplePayments}
              setPaymentSelected={setPaymentSelected}
              paymentSelected={paymentSelected}
              handlePaymentFormValidation={handlePaymentFormValidation}
              handleCardSelect={handleCardSelect}
              scrollToPaymentSelect={scrollToPaymentSelect}
              scrollToPaymentSelectDisabled={scrollToPaymentSelectDisabled}
              availableNewFlow={true}
              isCars={true}
            />
          ) : (stripeExpressEnabled && !isEmpty(paymentSelected) && paymentSelected !== 'card') ? (
            <BillingAddressForm
              formRef={billingRef}
              loading={loadingBooking}
              isRequired
              handleBillingFormValidation={handleBillingFormValidation}
              multiplePayments={multiplePayments}
              setPaymentSelected={setPaymentSelected}
              paymentSelected={paymentSelected}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    carsReviewBookStore: state.carsReviewBookStore,
    loginStore: state.loginStore,
  };
};

const mapDispatchToProps: IMapDispatchToProps = {
  setCard: setCarsCard,
};

export const CarsPayment = connect(mapStateToProps, mapDispatchToProps)(CarsPaymentComponent);
